import React, { useState } from 'react';

const InputForm = ({ onSubmit, submitCounter, validationMessage, setValidationMessage }) => {
  const [input, setInput] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim()) {
      onSubmit(input);
      setInput('');
    }
  };

  return (
      <form onSubmit={handleSubmit} className={`pc-input-form-wrapper${submitCounter > 0 ? ' input-form-hidden' : ''}`}>
        <div className="pc-input-form">
          <input
              type="text"
              aria-label="Enter URL of a privacy policy page"
              value={input}
              onChange={({ target: { value } }) => {
                setInput(value);
                setValidationMessage(''); // Clear the validation message when user starts typing
              }}
              placeholder="Enter URL of a privacy policy page..."
          />
          <button type="submit">Explain</button>
        </div>
        {validationMessage &&
        <div className="pc-validation-message">{validationMessage}</div>}
      </form>
  );
};

export default InputForm;
